import React, { ReactElement, ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { TaskState } from '@wix/bex-core';

function _InitialLoadingConditional({
  children = null,
  fallback = null,
  state,
}: {
  children?: ReactNode;
  fallback?: ReactElement | null;
  state: { initTask: TaskState<unknown> };
}) {
  const { initTask } = state;

  if (initTask.status.isIdle || initTask.status.isLoading) {
    return fallback;
  }

  if (initTask.status.isError) {
    return null;
  }

  return <>{children}</>;
}

export const InitialLoadingConditional = observer(_InitialLoadingConditional);
